import { computed, Directive, inject } from '@angular/core'
import { PermissionService } from '@core/auth/services/permission.service'
import { CategoryService } from '@core/auth/services/category.service'
import { CertificateHolderRowType } from '@features/certificate/utils/certificate-holder-search.util'

@Directive()
export abstract class CertificateBaseComponent {
  protected readonly permissionService = inject(PermissionService)
  protected readonly categoryService = inject(CategoryService)
  public readonly canEdit = computed(() => {
    const cat = this.categoryService.activeCategory()
    return cat === null ? false : this.permissionService.canEdit(cat)
  })
  protected readonly certificateHolderRowType = CertificateHolderRowType
}
